import React from 'react'

import { legacyImageURL } from 'components/LegacyImage'
import PlaceHolderImage from 'components/PlaceholderImage'

const ProductSelectorScreen = React.forwardRef(
  ({ review, onSelect, onSkip }, ref) => {
    // const ProductSelectorScreen = ({ review, onSelect, onSkip }) => {

    return (
      <div className={`product-selector`} ref={ref}>
        <h1 dangerouslySetInnerHTML={{ __html: review.productSelectorTitle }} />
        <div
          className="selector-header"
          dangerouslySetInnerHTML={{
            __html: review.productSelectorDescription,
          }}
        />
        <div className="product-list">
          {review.products &&
            review.products.map((product, i) => {
              return (
                <div
                  className={`product clickable`}
                  key={i}
                  role="link"
                  tabIndex="0"
                  onClick={e => {
                    onSelect && onSelect(product.productId)
                  }}
                  onKeyDown={e => {
                    if (e.keycode === 13) {
                      onSelect && onSelect(product.productId)
                    }
                  }}
                >
                  <PlaceHolderImage
                    src={legacyImageURL(product.image)}
                    alt={product.dropdownTitle}
                    width={300}
                    height={200}
                  />
                  <h2 dangerouslySetInnerHTML={{ __html: product.title }} />
                  <div
                    className={`description`}
                    dangerouslySetInnerHTML={{
                      __html: product.selectorDescription,
                    }}
                  />
                </div>
              )
            })}
        </div>
        <div
          className="selector-footer"
          dangerouslySetInnerHTML={{ __html: review.productSelectorFooter }}
        />
        {review.enableReminders && (
          <div className="selector-skip ">
            <span
              role="link"
              className="btn"
              tabIndex="0"
              onClick={onSkip}
              onKeyDown={e => {
                if (e.keycode === 13) {
                  onSelect && onSkip()
                }
              }}
              dangerouslySetInnerHTML={{ __html: review.notFamiliarCopy }}
            />
          </div>
        )}
      </div>
    )
  },
)

export default ProductSelectorScreen
